import React, { Component } from 'react';
import PropTypes from 'prop-types';
import googleAuth from '../../providers/googleAuth';
import authStorage from '../../../storages/mobx/authStorage';

class GoogleAuthButton extends Component {
  render() {
    return (
      <button
        className="btn social-btn btn-google d-inline-block"
        type="button"
        onClick={() => googleAuth(authStorage.setCredientials, authStorage.processError)}
      >
        <i className="fa fa-google" />
      </button>
    );
  }
}

GoogleAuthButton.propTypes = {};

export default GoogleAuthButton;
